import * as getters from '@/store/modules/companyPayments/requestTPA/getters'
import * as mutations from '@/store/modules/companyPayments/requestTPA/mutations'
import * as actions from '@/store/modules/companyPayments/requestTPA/actions'

const state = {
    tpasTypes: [],
    accountsBalances: [],
    companyData: {},
    locations: [],
    agenciesProvinces: [],
    branches: [],
    economicActivities: [],
    authorizedOperations: [],
    acceptedCards: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
